import React from 'react';
import { Model } from "@singularsystems/neo-core";
import { Neo, NeoGrid } from "@singularsystems/neo-react";
import { CatalogueEntry } from "../CatologueEntry"
import DataCache from "../../StaticData/StaticDataCache";
import { IGeneralApiClient } from "../../../Common/ApiClients/GeneralApiClient";
import { Catalogue } from "@singularsystems/neo-react-services";
import * as Roles from "../../../AccessControl/Models/Commands/Security/Roles"
import { TextConstants } from '../../../Common/TextConstants';
import DestinationFieldLookup from '../../GenericMappings/Models/Lookups/DestinationFieldLookup';
import DestinationTableLookup from '../../GenericMappings/Models/Lookups/DestinationTableLookup';

export default class DestinationTableCatalogueEntry extends CatalogueEntry<DestinationTableLookup> {

    constructor() {
        super("Destination Tables", DestinationTableLookup);
    }

    public get editRole() {
        return Roles.CatalogueRoles.Edit;
    }

    public getCacheEntry(cache: DataCache) {
        return cache.destinationTables;
    }
    
    public getSaveEndpoint(apiClient: IGeneralApiClient) {
        return apiClient.saveDestinationTableList;
    }
    
    public renderRow(item: DestinationTableLookup, meta: Model.TransformMetaType<DestinationTableLookup>) {
        return (
            <NeoGrid.Row>
                <NeoGrid.Column bind={meta.destinationTableName} />
                <Catalogue.ButtonColumn />
            </NeoGrid.Row>
        )
    }
}